import React from 'react'
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Row, Col } from 'react-bootstrap'
import TvChanne from './tvchannel.component'
import { Link } from 'react-router-dom'
// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade, Navigation, Thumbs, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
SwiperCore.use([EffectFade, Navigation, Thumbs, Pagination]);



const mapStateToProps = (state) => {
    return {
    };
}

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(
        {
        },
        dispatch
    )
})



export class TvChannelList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataMap: props.dataMap,
            tagName: props.tagName,
            id: props.id,
            viewAllUrl: props.viewAllUrl,
            prevId: 'prev' + props.id,
            nextId: 'next' + props.id,
        };
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="d-veuitbgimg">
                <div className="main-content" id="main-content">
                    <section id="iq-favorites">
                        <Container fluid id="d-container">
                            <Row id="d-space-show">
                                <Col sm="12" className="overflow-hidden d-set-overflow p-0">
                                    <div className="d-flex align-items-center justify-content-between set-view-all-text">
                                        <h3 className="main-title text-uppercase d-movie-title">{this.state.tagName}</h3>
                                        <Link className="iq-view-all d-view-text" to={this.state.viewAllUrl}>VIEW ALL</Link>
                                    </div>
                                    <div id="favorites-contens">
                                        <div id={this.state.prevId} className="swiper-button swiper-button-prev d-set-prev"><i className="fa fa-chevron-left d-icon"></i></div>
                                        <div id={this.state.nextId} className="swiper-button swiper-button-next d-set-next"><i className="fa fa-chevron-right d-icon"></i></div>
                                        <Swiper
                                            navigation={{
                                                prevEl: '#' + this.state.prevId,
                                                nextEl: '#' + this.state.nextId
                                            }}
                                            breakpoints={{
                                                // 320: { slidesPerView: 1.37 },
                                                // 345: { slidesPerView: 1.48 },
                                                // 360: { slidesPerView: 1.54 },
                                                // 375: { slidesPerView: 1.62 },
                                                // 390: { slidesPerView: 1.68 },
                                                // 414: { slidesPerView: 1.78 },
                                                // 430: { slidesPerView: 1.85 },
                                                // 480: { slidesPerView: 2.080 },
                                                // 576: { slidesPerView: 2.489 },
                                                // 767: { slidesPerView: 2.150 },
                                                // 991: { slidesPerView: 2.8 },
                                                // 1366: { slidesPerView: 3.85 },
                                                // 1440: { slidesPerView: 4.1 },
                                                // 1680: { slidesPerView: 4.8 },
                                                // 1920: { slidesPerView: 5.5 },

                                                2560: {
                                                    slidesPerView: 8, 
                                                    spaceBetween: 20, 
                                                },
                                                2304: {
                                                    slidesPerView: 7, 
                                                    spaceBetween: 20, 
                                                },
                                                2150: {
                                                    slidesPerView: 7, 
                                                    spaceBetween: 22, 
                                                },
                                                1920: {
                                                    slidesPerView: 6, 
                                                    spaceBetween: 20, 
                                                },
                                                1800: {
                                                    slidesPerView: 6,
                                                    spaceBetween: 20, 
                                                },
                                                1680: {
                                                    slidesPerView: 5,
                                                    spaceBetween: 22, 
                                                },
                                                1536: {
                                                    slidesPerView: 5,
                                                    spaceBetween: 20, 
                                                },
                                                1440: {
                                                    slidesPerView: 5,
                                                    spaceBetween: 5, 
                                                },
                                                1366: {
                                                    slidesPerView: 4,
                                                    spaceBetween: 22, 
                                                },
                                                1280: {
                                                    slidesPerView: 4,
                                                    spaceBetween: 22, 
                                                },
                                                1054: {
                                                    slidesPerView: 4,
                                                    spaceBetween: 8, 
                                                },
                                                991: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 22, 
                                                },
                                                900: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 5, 
                                                },
                                                840: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 5, 
                                                },
                                                767: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 22, 
                                                },
                                                700: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 5, 
                                                },
                                                577: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 5, 
                                                },
                                                576: {
                                                    slidesPerView: 3,
                                                    // spaceBetween: 5, 
                                                },
                                                480: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 5, 
                                                },
                                                430: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 5, 
                                                },
                                                376: {
                                                    slidesPerView: 3,
                                                    spaceBetween: 5, 
                                                },
                                                375: {
                                                    slidesPerView: 2.2,
                                                    spaceBetween: -13, 
                                                },
                                                360: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 25, 
                                                },
                                                345: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 8, 
                                                },
                                                320: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 5, 
                                                },

                                                
                                                

                                            }}
                                            loop={false}
                                            // slidesPerView={8}
                                            as="ul"
                                            className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction">

                                            {this.state.dataMap.map((item, key) => {
                                                return (
                                                    <SwiperSlide as="li" key={key} id="d-tvchannel-slider">
                                                        <TvChanne resultObject={item}
                                                            id={item.id}
                                                        />
                                                    </SwiperSlide>
                                                )
                                            })}

                                        </Swiper>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TvChannelList)